/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {frequenceOptions} from '../../../../../../data/constants/Assurance/assuranceRetraite';
import {dataOption} from '../../../../../../data/types/interface/input';
import {buttonsStyles} from '../../../../../components/Button/boutonStyle';
import Button from '../../../../../components/Button/PrimaryButton';
import {DateTimePickerWeb} from '../../../../../components/Inputs/DateTimePicker/index.web';
import Input from '../../../../../components/Inputs/Input';
import Select from '../../../../../components/Inputs/Select';

const aList: dataOption[] = frequenceOptions;

export default function FormCotisation({
  callBack,
  submit,
  defaultValue,
  requiredFields,
  isSubmited,
}: any) {
  React.useEffect(() => {}, [defaultValue]);
  return (
    <View>
      <DateTimePickerWeb
        defaultValue={defaultValue.DateNaissance}
        label="Date de naissance"
        callBack={(data: any) => {
          callBack('DateNaissance', data);
        }}
        requiredField={requiredFields.DateNaissance}
        maxAge={60}
        required
      />

      <Input
        defaultValue={defaultValue.Pension}
        label="La rente souhaitée à 60 ans (Ar)"
        name="Pension"
        parentCallback={(data: any) => callBack('Pension', data)}
        required
        type="numeric"
        requiredField={requiredFields.Pension}
        isSubmited={isSubmited}
      />
      <Select
        data={aList}
        label="Mode de versement de la cotisation"
        value={defaultValue.ModeVersement}
        required={true}
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        onChange={(name: string, data: any, fired: boolean) => {
          callBack('ModeVersement', data);
        }}
      />

      <View style={buttonsStyles.displayCenter}>
        <View style={buttonsStyles.displayHorizontal}>
          <Button
            onPress={() => submit(false, 'Pension')}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuter}
            title="Annuler"
            type="annuler"
          />
          <Button
            onPress={() => submit(true, 'Pension')}
            styleBtnTxt={buttonsStyles.btnValider}
            styleBtnOuter={buttonsStyles.btnValiderOuter}
            title="Valider"
            type="valider"
          />
        </View>
      </View>
    </View>
  );
}
